<div class="center-block text-center">
  <div *ngIf="reauthenticationInProgress">
      <i class="fa fa-spinner fa-pulse fa-5x text-center"></i>
  </div>
  <div *ngIf="!reauthenticationInProgress">
    <h3>The system did not recognize this public access terminal. This may be a temporary condition. If the problem persists, please ask the clerk to contact technical support.</h3>
    <button class="btn btn-primary" (click)="attemptAuthentication()">Try again</button>
  </div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/shared/public-access-terminal.component.html